import React, { Component } from 'react'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  jumpToRoomNew,
  inject,
  observer,
  openViewTransparent,
  closeWebview,
  jumpToGames
} from '../../../helper/devTools.js'

import dsbridge from 'dsbridge'
import { createRoomSuccess, jumpToWelfare } from '../../../helper/webviewFun'
import Message from '../../../component/Message'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('New User Task')
    openViewTransparent(true)
  }
  state = {
    lang: {},
    messageTxt: "",
    tasksList: [],
    welfareList: [],
    isAllCompleted: 0,
    isShowResult: false,
    language:'en',
  }

  async initLang() {
    let { language } = this.props.location.query
    language = await getlang(language)
    this.setState({
      lang: setlang(language, this.welfareStore.data.userLang),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async initList() {
    let tasksList = await this.welfareStore.apiGetNewUserTaskList()
    let welfareList = await this.welfareStore.apiGetNewUserWelfareList()
    console.log(tasksList)
    console.log(welfareList)
    this.setState({
      tasksList: tasksList && tasksList.res && tasksList.res.taskList,
      welfareList: welfareList && welfareList.res,
      isAllCompleted: tasksList && tasksList.res && tasksList.res.isAllCompleted,
    })
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
    this.initList()

    // 返回页面时回调
    dsbridge.register('onWebViewShow', () => {
      this.initList()
    })
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    try {
      this.setState({
        uid: uid
      })
      let getUserInfo = await this.welfareStore.GetUserInfoWeb(uid)
      if (getUserInfo && getUserInfo.code == 0) {
        this.setState({
          userInfo: getUserInfo.res
        })
      }
    } catch (error) {
      console.error(error)
      this.refs.msg.show("error")
    }
  }

  async goApp(type) {
    if (type == 1) {
      try {
        let gid = await this.welfareStore.getRandomTopThirty()
        jumpToRoomNew(gid)
        closeWebview()
      } catch (error) {
        console.error(error)
        this.refs.msg.show(error)
      }
    }
    if (type == 2) {
      try {
        let gid = await this.welfareStore.getRandomTopThirty()
        jumpToGames(4, gid)
        closeWebview()
      } catch (error) {
        console.error(error)
        this.refs.msg.show(error)
      }
    }
    if (type == 3) {
      try {
        let isCreate = await this.welfareStore.apiCreateRoom()
        if (isCreate && isCreate.code == 0) {
          await createRoomSuccess()
          jumpToRoomNew(isCreate.res && isCreate.res.gid)
          this.refs.msg.show(this.state.lang.cSuc)
        } else {
          this.refs.msg.show(this.state.lang.rExi)
        }
      } catch (error) {
        console.error(error)
        this.refs.msg.show(error)
      } finally {
        this.initList()
      }
    }
    if (type == 4) {
      try {
        let gid = await this.welfareStore.getRandomOnlineMic()
        jumpToRoomNew(gid)
        closeWebview()
      } catch (error) {
        console.error(error)
        this.refs.msg.show(error)
      }
    }
    if (type == 5) {
      let gid = await this.welfareStore.getRandomTopThirty()
      jumpToGames(1, gid)
      closeWebview()
    }
  }

  async getReward() {
    console.log("领取奖励")
    let getReward = await this.welfareStore.getNewUserWelfareReward()
    if (getReward && getReward.res == 0) {
      this.setState({
        isShowResult: true
      })
    }
    if (getReward && getReward.res == 1) {
      this.refs.msg.show(this.state.lang.hadGet)
    }
    if (getReward && getReward.res == 2) {
      this.refs.msg.show(this.state.lang.undone)
    }
  }

  handleClose() {
    this.setState({
      isShowResult: false
    })
    closeWebview()
    jumpToWelfare()
  }

  render() {
    return (
      <div className={`welfare-user-main-container`}>
        <Message ref="msg" />

        <div className="draw-result-outer" style={{ display: `${this.state.isShowResult ? "flex" : "none"}` }}>
          <div className="draw-result">
            <div className="title">{this.state.lang.getSuc}</div>
            <div className="content" style={{ display: `flex` }}>
              <div className="img-outer">
                <img src={"/img/activity/welfare/done.png"} alt="" />
              </div>
            </div>
            <div className="yes" onClick={() => { this.handleClose() }}>{this.state.lang.more}</div>
          </div>
        </div>



        <div className="w-u-content">
          {/* <div className="welfare-close" onClick={() => { this.closePage() }}></div> */}
          <div className="welfare-banner" style={{ fontSize: `${this.state.language == 'ar' && '0.24rem'}` }}>
            {this.state.lang.nw}
          </div>
          <div className="welfare-bg"></div>

          <div className="w-u-outer-scroll">
            <div className="welfare-user-main-wrapper">
              <div className="r-content">
                {this.state.welfareList && this.state.welfareList.map((i, k) => {
                  return (
                    <div className="r-item" key={k}>
                      <div className="r-light">
                        <img src={i.img} alt="" />
                        <p>{i.title}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
              {this.state.isAllCompleted == 0 && (<div className="draw-no">{this.state.lang.allDone}</div>)}
              {this.state.isAllCompleted == 1 && (<div className="draw-btn" onClick={() => { this.getReward() }}>{this.state.lang.get}</div>)}
              {this.state.isAllCompleted == 2 && (<div className="draw-btn2">{this.state.lang.hadGet}</div>)}
            </div>
            <div className="w-u-items">
              {
                this.state.tasksList && this.state.tasksList.map((i, k) => {
                  if (i.type != 5 && i.icon != "https://img.chatie.live/app/daily_task/game.png") { // 排除游戏任务
                    return (
                      <div className="w-u-item" key={k}>
                        <div className="left"><img src={i.icon} /></div>
                      <div className="middle">{i.title}</div>
                      <div className="right"
                        onClick={() => { this.goApp(i.type) }}
                        style={{ display: `${i.status == 0 ? "flex" : "none"}` }}>
                        <span>{this.state.lang.go}</span>
                      </div>
                      <div className="right" style={{ display: `${i.status == 1 ? "flex" : "none"}` }}>
                        <img src="/img/activity/welfare/right.png" alt="" />
                      </div>
                    </div>
                    )
                  }
                })
              }
            </div>
            <div className="desc">
              {this.state.lang.newUser}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/welfare-user/index.js